import Yelp from "../../assets/images/png/Yelp.png";
import Instagram from "../../assets/images/png/Instagram.png";
import Facebook from "../../assets/images/png/Facebook.png";
import Twitter from "../../assets/images/png/Twitter.png";

const SocialMediaIcons = () => {
  return (
    <div className="social-section">
      <div className="social-icons">
        <a className="social-icon" target="_blank" href="https://www.facebook.com/OmniActiveFitness">
          <img className="social-img" src={Facebook} alt="facebook icon" />
        </a>
        <a className="social-icon" target="_blank" href="https://www.instagram.com/omniactivefitness/">
          <img className="social-img" src={Instagram} alt="insta icon" />
        </a>
        <a className="social-icon" target="_blank" href="https://twitter.com/Omni_Active">
          <img className="social-img" src={Twitter} alt="" />
        </a>
        <a className="social-icon" target="_blank" href="https://www.yelp.com/biz/omni-active-fitness-cleveland-2">
          <img className="social-img" src={Yelp} alt="" />
        </a>
      </div>
    </div>
  );
};
export default SocialMediaIcons;
